import accountIcon from '@/assets/images/icons/nav/account.svg';
import accountActiveIcon from '@/assets/images/icons/nav/account-active.svg';
import draftsIcon from '@/assets/images/icons/nav/drafts.svg';
import draftsActiveIcon from '@/assets/images/icons/nav/drafts-active.svg';
import gameIcon from '@/assets/images/icons/nav/game.svg';
import gameActiveIcon from '@/assets/images/icons/nav/game-active.svg';
import helpIcon from '@/assets/images/icons/nav/help.svg';
import helpActiveIcon from '@/assets/images/icons/nav/help-active.svg';
import homeIcon from '@/assets/images/icons/nav/home.svg';
import homeActiveIcon from '@/assets/images/icons/nav/home-active.svg';
import insightsIcon from '@/assets/images/icons/nav/insights.svg';
import insightsActiveIcon from '@/assets/images/icons/nav/insights-active.svg';
import inviteIcon from '@/assets/images/icons/nav/invite.svg';

import { ImgHTMLAttributes, ReactElement } from 'react';

interface IconProps extends ImgHTMLAttributes<HTMLImageElement> {
  src: string;
  alt: string;
}

interface NavIconProps extends ImgHTMLAttributes<HTMLImageElement> {
  active?: boolean;
}

export const Icon = ({ src, alt, ...props }: IconProps): ReactElement => {
  return <img src={src} alt={alt} {...props} />;
};

export const AccountIcon = ({ active = false, ...props }: NavIconProps): ReactElement => {
  return <Icon src={active ? accountActiveIcon : accountIcon} alt="account icon" {...props} />;
};

export const DraftsIcon = ({ active = false, ...props }: NavIconProps): ReactElement => {
  return <Icon src={active ? draftsActiveIcon : draftsIcon} alt="drafts icon" {...props} />;
};

export const GameIcon = ({ active = false, ...props }: NavIconProps): ReactElement => {
  return <Icon src={active ? gameActiveIcon : gameIcon} alt="game icon" {...props} />;
};

export const HelpIcon = ({ active = false, ...props }: NavIconProps): ReactElement => {
  return <Icon src={active ? helpActiveIcon : helpIcon} alt="help icon" {...props} />;
};

export const HomeIcon = ({ active = false, ...props }: NavIconProps): ReactElement => {
  return <Icon src={active ? homeActiveIcon : homeIcon} alt="home icon" {...props} />;
};

export const InsightsIcon = ({ active = false, ...props }: NavIconProps): ReactElement => {
  return <Icon src={active ? insightsActiveIcon : insightsIcon} alt="insights icon" {...props} />;
};

export const InviteIcon = ({ ...props }: NavIconProps): ReactElement => {
  return <Icon src={inviteIcon} alt="invite icon" {...props} />;
};
